<div class="people-picker-container flex-column">
  <mat-form-field>
    <mat-chip-grid
      #chipGrid
      aria-label="Enter users"
      [ngClass]="{ 'scroll-people-picker': isQueryBuilder() }"
    >
      @for (user of selectedUserMail; track user.mail; let i = $index) {
        <mat-chip-row (removed)="removeUser(user)" class="user-chip">
          {{ user.displayName }}
          <button
            matChipRemove
            [attr.aria-label]="'remove ' + user.displayName"
          >
            <span class="material-symbols-outlined custom-cancel">cancel</span>
          </button>
        </mat-chip-row>
      }
      <input
        #userInput
        [placeholder]="'searchByUser' | translate"
        [matChipInputFor]="chipGrid"
        [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
        [matAutocomplete]="auto"
        [formControl]="userControl"
      />
      <mat-autocomplete
        #auto="matAutocomplete"
        (optionSelected)="selectedUser($event)"
      >
        @for (
          user of peoplePickerList();
          track user.displayName;
          let i = $index
        ) {
          <mat-option [value]="user">{{ user.displayName }}</mat-option>
        }
      </mat-autocomplete>
    </mat-chip-grid>
  </mat-form-field>
</div>
